import get from "lodash/get";
import set from "lodash/set";
import pick from "lodash/pick";
import each from "lodash/each";

function getFilename(str) {
  return new String(str).substring(str.lastIndexOf("/") + 1);
}

function getThumbName(items) {
  return items.map(item => {
    const filename = getFilename(item.name);
    return item.name.replace(filename, `thumb_${filename}`);
  });
}

function parseDbSnap(snap) {
  let res;

  if (snap.size !== undefined) {
    res = [];
    snap.forEach(doc => {
      const data = doc.data();
      const id = doc.id;
      set(data, "temp.id", id);
      res.push(data);
    });
  } else {
    const data = snap.data();
    const id = data.id;
    set(data, "temp.id", id);
    res = data;
  }

  return res;
}

function parseTimestamp(time) {
  const sec = time.seconds;
  if (!sec) return "";
  return new Date(sec * 1000).toLocaleDateString();
}

export default {
  get,
  set,
  pick,
  each,
  parseDbSnap,
  parseTimestamp,
  getFilename,
  getThumbName
};
